import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../shared/services/auth.service';
import { lastValueFrom, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  AmountGraph,
  AverageTicket,
  Convert,
  SalesAverage,
  SalesCount,
  SalesSum,
  SalesToday,
} from './dashboard.model';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl   
        : environment.apiUrl;

    return `${base}${path}`;
  }

  getAvailableBalanceAmount(): Promise<number> {
    return lastValueFrom(
      this.http.get<number>(this.url('/account/readyAmount'))
    );
  }

  getGeneralBalanceAmount(): Promise<number> {
    return lastValueFrom(
      this.http.get<number>(this.url('/account/amount'))
    );
  }

  getBlockedBalanceAmount(): Promise<number> {
    return lastValueFrom(
      this.http.get<number>(`${environment.apiUrl}/account/blockedAmount`)
    );
  }

  getSalesToday(): Promise<SalesToday> {
    return lastValueFrom(
      this.http.get<SalesToday>(this.url('/dashboard/salesToday'))
    );
  }

  getSalesAverage(): Promise<SalesAverage> {
    return lastValueFrom(
      this.http.get<SalesAverage>(this.url('/dashboard/salesAverage'))
    );
  }

  getSalesCount(): Promise<SalesCount> {
    return lastValueFrom(
      this.http.get<SalesCount>(this.url('/dashboard/salesCount'))
    );
  }

  getSalesSum(): Promise<SalesSum> {
    return lastValueFrom(
      this.http.get<SalesSum>(this.url('/dashboard/salesSum'))
    );
  }

  getAverageTicket(): Promise<AverageTicket> {
    return lastValueFrom(
      this.http.get<AverageTicket>(this.url('/dashboard/averageTicket'))
    );
  }

  getConvert(): Promise<Convert> {
    return lastValueFrom(
      this.http.get<Convert>(this.url('/dashboard/convert'))
    );
  }

  getLast7DaysSales(): Promise<AmountGraph> {
    return lastValueFrom(
      this.http.get<AmountGraph>(this.url('/dashboard/last7DaysSales'))
    );
  }

  getLast7DaysReceivedSales(): Promise<AmountGraph> {
    return lastValueFrom(
      this.http.get<AmountGraph>(this.url('/dashboard/last7DaysReceivedSales'))
    );
  }

  getLastYearSales(): Promise<AmountGraph> {
    return lastValueFrom(
      this.http.get<AmountGraph>(this.url('/dashboard/lastYearSales'))
    );
  }

  getLastYearReceivedSales(): Promise<AmountGraph> {
    return lastValueFrom(
      this.http.get<AmountGraph>(this.url('/dashboard/lastYearReceivedSales'))
    );
  }

  getLastYearWithdrawSales(): Promise<AmountGraph> {
    return lastValueFrom(this.http.get<AmountGraph>(this.url('/dashboard/lastYearWithdrawSales'))
    );
  }
}
